// Tier utilities — derive user's current tier from localStorage unlock flags

export const TIERS = {
  BASIC: 'basic',
  PRO: 'pro',
  ULTIMATE: 'ultimate',
};

export const TIER_LEVEL = {
  basic: 0,
  pro: 1,
  ultimate: 2,
};

/**
 * Returns current user tier from localStorage flags.
 * - bundle_unlocked => ultimate
 * - pro_unlocked    => pro
 * - otherwise       => basic
 */
export function getCurrentTier() {
  if (typeof window === 'undefined') return TIERS.BASIC;
  if (localStorage.getItem('bundle_unlocked') === 'true') return TIERS.ULTIMATE;
  if (localStorage.getItem('pro_unlocked') === 'true') return TIERS.PRO;
  return TIERS.BASIC;
}

/**
 * Check if a user with `userTier` can access an exercise with `exerciseTier`.
 * Access is granted if userTier >= exerciseTier.
 */
export function canAccess(userTier, exerciseTier) {
  return TIER_LEVEL[userTier] >= TIER_LEVEL[exerciseTier || 'basic'];
}

/**
 * Returns the tier name a user needs to upgrade TO in order to access this exercise.
 */
export function nextUpgradeTier(exerciseTier) {
  if (exerciseTier === 'pro') return TIERS.PRO;
  if (exerciseTier === 'ultimate') return TIERS.ULTIMATE;
  return null;
}
